export const TAG_BLACKLIST = ["size", "author", "color"];
